import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { FccomboBusiness } from '../business/fccombo.business';
/**
 * fc-comboåéä¸ææ¡
 * 
 * å¼¹åºä¸ä¸ªä¸æèåç»ç¨æ·éæ©æä½ï¼ç¨äºä»£æ¿åççéæ©å¨ï¼æèéè¦ä¸ä¸ªæ´ä¼éçå¤éå¨æ¶ã
 * 
 * å½éé¡¹å°æ¶ï¼å°äº 5 é¡¹ï¼ï¼å»ºè®®ç´æ¥å°éé¡¹å¹³éºï¼ä½¿ç¨ Radio æ¯æ´å¥½çéæ©ã
 * 
 * 
 * äºä»¶ï¼
 * 
 * 1.æ¸é¤äºä»¶ï¼clear
 * 
 */
@Component({
    selector: 'fc-combo',
    template: `
    <nz-select  [nzFilterOption]="fcFilterOption"  [nzDropdownClassName]="fcDropdownClassName" [nzDropdownStyle]="fcDropdownStyle"  class="fc-combo"  *ngIf="fcShowLabel==='N'" [ngClass]="{'fc-readonly':_readonly===true}" (nzOpenChange)="_event('openChange',$event)" [nzServerSearch]="fcServerSearch==='Y'" [nzDisabled]="_disabled" [nzShowSearch]="fcShowSearch" (nzOnSearch)="_event('search',$event)"
    [(ngModel)]="_selectOptions" [nzSize]="fcSize" (ngModelChange)="_event('valueOnChange',$event)" [nzNotFoundContent]="fcNotFoundContent" (nzScrollToBottom)="_event('scrollToBottom',$event)" 
    [nzPlaceHolder]="fcPlaceHolder" [nzAllowClear]="_allowClear" [nzDropdownMatchSelectWidth]="_autoSize" [nzOpen]="_open" [nzAutoFocus]="fcAutoFocus==='Y'">
        <nz-option *ngFor="let option of _options" (click)="_event('click',option)" [nzLabel]="option.label" [nzValue]="option" [nzDisabled]="option.disabled"></nz-option>
        <nz-option *ngIf="fcLoading==='Y'" nzDisabled nzCustomContent>
        <i nz-icon type="loading" class="loading-icon"></i> æ­£å¨å è½½ä¸­...
      </nz-option>
    </nz-select>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-select  [nzFilterOption]="fcFilterOption" [nzDropdownClassName]="fcDropdownClassName" [nzDropdownStyle]="fcDropdownStyle"  class="fc-combo" [ngClass]="{'fc-readonly':_readonly===true}" (nzOpenChange)="_event('openChange',$event)" [nzServerSearch]="fcServerSearch==='Y'" [nzDisabled]="_disabled" [nzSize]="fcSize" [nzShowSearch]="fcShowSearch" (nzOnSearch)="_event('search',$event)" 
                    [(ngModel)]="_selectOptions" (ngModelChange)="_event('valueOnChange',$event)" [nzNotFoundContent]="fcNotFoundContent" [nzPlaceHolder]="fcPlaceHolder" 
                    [nzAllowClear]="_allowClear" [nzDropdownMatchSelectWidth]="_autoSize" [nzOpen]="_open" [nzAutoFocus]="fcAutoFocus==='Y'" (nzScrollToBottom)="_event('scrollToBottom',$event)">
                        <nz-option *ngFor="let option of _options" (click)="_event('click',option)" [nzLabel]="option.label" [nzValue]="option" [nzDisabled]="option.disabled"></nz-option>
                        <nz-option *ngIf="fcLoading==='Y'" nzDisabled nzCustomContent>
                        <i nz-icon type="loading" class="loading-icon"></i> æ­£å¨å è½½ä¸­...
                        </nz-option>
            </nz-select>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div> 
        </div>
    </div>
  `,
    styles: [`
        .fc-combo{
            width:100%
        }
        .fc-readonly {
            pointer-events: none;
        }
        :host ::ng-deep .fc-readonly .ant-select-selection{
            background-color: #f5f5f5;
        }
        .form-explain {
            position:relative;
        }
        .explain{
            white-space: nowrap;
            position:absolute;
            right: -1px;
            bottom: 24px;
            z-index:10;
        }
        .explain-inner {
            position:relative;
            color:red;
        }
        .explain-inner:after{
            content: '';
            width: 10px;
            height: 12px;
            display: block;
            background-color: #ffffff;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            position: absolute;
            bottom: -6px;
            right: 12px;
            transform: rotate(45deg);
            z-index: 0;
        }
        .explain-tips{
            padding: 0px 10px;
            background-color: #ffffff;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            font-size: 12px;
            height: 30px;
            line-height: 28px;
        }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FccomboComponent),
        multi: true
    }]
})
export class FccomboComponent extends FcinputComponent {
    @Input()
    fcFilterOption: Function;
    @Input()
    fcDropdownClassName: string;
    @Input()
    fcDropdownStyle: string;
    // é¦è¡ç©ºè¡
    @Input()
    fcLineOneSpace: string;
    /*æ¯å¦loading */
    @Input()
    fcLoading = 'N';
    /** åéå¼*/
    @Input()
    fcOption: any[];
    _options: any[] = [];
    _selectOptions: any;
    /** æ¯å¦å¯ç¨æç´¢*/
    @Input()
    fcShowSearch: boolean = true;
    @Input()
    fcServerSearch: string = 'N';
    /**labelå­æ®µåç§°*/
    @Input()
    fcLabelCode: string;
    /**valueå­æ®µåç§°*/
    @Input()
    fcValueCode: string;
    /**disabledå­æ®µåç§°*/
    @Input()
    _disabledCode: string;
    /**æ¯å¦æ¯ææ¸é¤*/
    @Input()
    fcAllowClear: string;
    _allowClear: boolean;
    /**åå®¹ç­å®½*/
    @Input()
    fcAutoSize: string;
    _autoSize: boolean;
    /**æ¯å¦æå¼ä¸æ*/
    @Input()
    fcOpen: string;
    _open: boolean;

    @Input()
    fcAutoFocus: string;
    /** å½åè¡¨ä¸ºç©ºæ¶æ¾ç¤º*/
    @Input()
    fcNotFoundContent: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-combo');
        FccomboBusiness.initData(this, {});
    }

    _afterParentInit(param) {
        if ((param && Object.keys(param).length === 0) || !param) {
            // çæ§æ¯å¦åçå¼åå
            FccomboBusiness.valueChange(this, param);
            return;
        }
        FccomboBusiness.changeOption(this, param);
        /**æ¯å¦æ¯ææ¸é¤*/
        this._allowClear = this.fcAllowClear === "Y";
        /**åå®¹ç­å®½*/
        this._autoSize = this.fcAutoSize === 'N';
        /**æ¯å¦æå¼ä¸æ*/
        this._open = this.fcOpen === 'Y';
        /**æ¯å¦ç¦ç¨*/
        this._disabled = this.fcDisabled === 'Y';
        /**æ¯å¦åªè®*/
        this._readonly = this.fcReadonly === 'Y';
        // çæ§æ¯å¦åçå¼åå
        FccomboBusiness.valueChange(this, param);

    }
    /**
     * åé¨äºä»¶å¤ç
     * @param eventName 
     * @param param 
     */
    _event(eventName: string, $event: any): void {
        switch (eventName) {
            case 'valueOnChange':
                FccomboBusiness.valueOnChange(this, $event);
                break;
            default:
                super.event(eventName, $event);
        }
    }
}


